import type { GetWorkflowDocumentDownloadUrlApiArg } from '~/api/k2/typedefs.autogen';
import type { ServiceRequestConfig } from '~/services/createService';

import {
  downloadDocument,
  type DownloadDocumentMode,
} from './downloadDocument';

export type DownloadWorkflowDocumentArg =
  GetWorkflowDocumentDownloadUrlApiArg & {
    mode?: DownloadDocumentMode;
    fileFormat?: string | null;
  };

export const downloadWorkflowDocument = (
  request: DownloadWorkflowDocumentArg,
  options?: ServiceRequestConfig,
): Promise<File> =>
  downloadDocument(`/workflows/${request.workflowId}`, request, options);
